import { useEffect, useMemo, useState } from 'react';

import { useAuth } from '../auth/AuthContext';
import { useSyncQueue } from '../services/syncQueue';
import { useMyTimesheetsAcrossJobs } from '../services/useWorker';

import { workerNeedsYou, type NeedsYouItem } from './workerNeedsYou';

/** Re-evaluated once a minute, so a day crossing midnight becomes "unfinished" without a reload. */
const TICK_MS = 60_000;

/**
 * UX 1A-c — the signed-in worker's "Vajab sind" items, for the shell's Päevad
 * counter. Pages that already hold the timesheets and the queue call the pure
 * `workerNeedsYou` themselves instead of subscribing twice.
 */
export function useWorkerNeedsYou(): NeedsYouItem[] {
  const { user } = useAuth();
  const { timesheets } = useMyTimesheetsAcrossJobs(user?.uid);
  const queue = useSyncQueue();
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), TICK_MS);
    return () => window.clearInterval(id);
  }, []);
  return useMemo(() => workerNeedsYou({ timesheets, queue, now }), [timesheets, queue, now]);
}
